<template>
  <component :is="mapLayout">
    <!-- router view -->
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, onMounted } from 'vue';
import { useStore } from 'vuex';
import useEditMode from '@composables/useEditMode';
import useAuth from '@composables/useAuth';
import useMobile from '@composables/useMobile';
import useDialog from '@composables/useDialog';
import MapMobileLayout from '@layouts/MapMobile.vue';
import MapDesktopLayout from '@layouts/MapDesktop.vue';

const store = useStore();
const { verify: verifyUserLoggedOnServer } = useAuth();
const { verifyEditSessions } = useEditMode();
const { show: showDialog } = useDialog();
const isMobile = useMobile();

const mapLayout = computed(() => {
  return isMobile() ? MapMobileLayout : MapDesktopLayout;
});

const verifyLoggedUser = async () => {
  const isLogged = store.getters['auth/isLogged'];
  if (isLogged) await verifyUserLoggedOnServer();
};

onBeforeMount(async () => {
  await verifyLoggedUser(); // verify preserved logged user on the server-side
  await verifyEditSessions(); // verify ongoing edit sessions on the server-side
});

onMounted(() => {
  if (isMobile() || !import.meta.env.VITE_TEXT_CITY_INFO_CS || !!store.state.layout.cityInfoSeen) return;
  showDialog({ type: 'cityInfo', modal: false, showHeader: false, position: 'bottomleft' }); // show city info dialog on app load - issue 86c6ugfxg
});
</script>
